import { forwardRef } from '@melio/platform-utils';

import { useCustomersFiltering } from './hooks';
import { CustomersTabScreen } from './screens';
import { CustomerActions } from './types';

export type CustomersTabActivityProps = {
  onCreateCustomer: VoidFunction;
  onCreateInvoice: (customerId: string) => unknown;
  onEditCustomer: (id: string) => unknown;
  onDisplayInvoices?: (customerId: string) => unknown;
  onError?: ErrorFunction;
};

export const CustomersTabActivity = forwardRef<CustomersTabActivityProps>(
  ({ onCreateCustomer, onCreateInvoice, onEditCustomer, onDisplayInvoices, onError, ...props }, ref) => {
    const { customers, isLoading, search, setParams, pagination } = useCustomersFiltering({ onError });

    const tableActions: CustomerActions = {
      onCreateInvoice,
      onEditCustomer,
      onDisplayInvoices,
    };

    return (
      <CustomersTabScreen
        customers={customers}
        tableActions={tableActions}
        isLoading={isLoading}
        search={search}
        onCreateCustomer={onCreateCustomer}
        onParamsChange={setParams}
        pagination={pagination}
        ref={ref}
        {...props}
      />
    );
  }
);
